/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import ColorGradient from 'javascript-color-gradient';

import injectSheet from 'react-jss';
import { Modal, Box } from '@mui/material';

import Tippy from '@tippyjs/react';
import '../../../tippy.js/dist/tippy.css';

import GroupStyles from './GroupM_Styles';

import { getTeams } from '../../../redux/features/teams/teams';
import { getPicks } from '../../../redux/features/picks/picks';
import { setPick } from '../../../redux/features/picks/picksSlice';

const styles = GroupStyles;

const GroupM = ({
  classes, name, teamz, pickz,
}) => {
  const dispatch = useDispatch();

  const teams = useSelector((state) => getTeams(state, teamz));
  const picks = useSelector((state) => getPicks(state, pickz));

  const handlePick = (_picks, teamId) => {
    const prev = _picks.find((pick) => pick.teamId === teamId);
    if (prev) {
      dispatch(setPick({ ...prev, teamId: null }));
      return;
    }
    const next = _picks.find((pick) => pick.teamId === null);
    if (next) {
      dispatch(setPick({ ...next, teamId }));
    }
  };

  return (
    <div className={classes.group}>
      <div className={classes.grouprow}>
        <div className={classes.dialog}>
          <div className={classes.card}>
            <div className={classes.dialoggroupname}>
              {name}
            </div>
            <div className={classes.dialoggroups}>
              {teams.map((team) => (
                <div
                  key={team.id}
                  className={classes.box}
                  style={{
                    borderColor: (() => {
                      if (picks[0].teamId === team.id) return '#62AD1D';
                      if (picks[1].teamId === team.id) return '#F9981D';
                      if (picks[0].teamId && picks[1].teamId) return '#ccc';
                      return 'lightgray';
                    })(),
                    backgroundColor: (() => {
                      if (picks[0].teamId === team.id) return '#F9F9FA';
                      if (picks[1].teamId === team.id) return '#f9f9fa';
                      return 'transparent';
                    })(),
                  }}
                >
                  <div
                    key={team.id}
                    className={classes.dialoggroup}
                    style={{
                      opacity: (() => {
                        if (picks[0].teamId === team.id) return '1';
                        if (picks[1].teamId === team.id) return '1';
                        if (picks[0].teamId && picks[1].teamId) return '0.4';
                        return '1';
                      })(),
                    }}
                  >
                    <div className={classes.flag} onClick={() => handlePick(picks, team.id)}>
                      <div
                        className={(() => {
                          switch (picks.findIndex((pick) => pick.teamId === team.id)) {
                            case 0: return classes.firstpicked;
                            case 1: return classes.secondpicked;
                            default: return classes.nopicked;
                          }
                        })()}
                        onClick={() => handlePick(picks, team.id)}
                      >
                        {picks.findIndex((pick) => pick.teamId === team.id) + 1
                          ? (
                            <div className={classes.picked}>
                              {picks.findIndex((pick) => pick.teamId === team.id) + 1}
                            </div>
                          )
                          : (
                            <div
                              className={classes.nonpick}
                              style={{
                                background: (() => {
                                  if (picks[0].teamId === team.id) return 'inherit';
                                  if (picks[1].teamId === team.id) return 'inherit';
                                  return `url(assets/images/flags/${team.id}.svg)`;
                                })(),
                              }}
                            />
                          )}
                      </div>
                    </div>
                    <div
                      className={classes.dialogteamname}
                      style={{
                        color: (() => {
                          if (picks[0].teamId === team.id) return '#62AD1D';
                          if (picks[1].teamId === team.id) return '#F9981D';
                          if (picks[0].teamId && picks[1].teamId) return '#ccc';
                          return '#666';
                        })(),
                      }}
                      onClick={() => handlePick(picks, team.id)}
                    >
                      <div>
                        {team.name}
                      </div>
                    </div>
                    {/* <div className={classes.chart}>
                      <div className={classes.label}>
                        {(() => {
                          if (picks[0].teamId === team.id) return '100%';
                          if (picks[1].teamId === team.id) return '100%';
                          if (picks[0].teamId && picks[1].teamId) return '0';
                          if (picks[0].teamId) return `${(100 * (Number(team.endfirst) + Number(team.endsecond))).toPrecision(3)}%`;
                          return `${(100 * team.endfirst).toPrecision(3)}%`;
                        })()}
                      </div>
                      <div className={classes.bars}>
                        <div className={classes.bar_back}>
                          <div
                            className={classes.bar_stats}
                            style={{
                              backgroundColor: (() => {
                                if (picks[0].teamId === team.id) return '#62AD1D';
                                if (picks[1].teamId === team.id) return '#F9981D';
                                if (picks[0].teamId) return '#F9981D';
                                return '#62AD1D';
                              })(),
                              width: (() => {
                                if (picks[0].teamId === team.id) return '100%';
                                if (picks[1].teamId === team.id) return '100%';
                                if (picks[0].teamId && picks[1].teamId) return '0';
                                if (picks[0].teamId) return `${100 * (Number(team.endfirst) + Number(team.endsecond))}%`;
                                return `${100 * team.endfirst}%`;
                              })(),
                            }}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className={classes.rank}>
                      <div>
                        FIFA:
                        {team.fifarank}
                      </div>
                      <div>
                        ELO:
                        {team.elorank}
                      </div>
                    </div>
                  </div>
                </div>

              ))}

            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

GroupM.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  teamz: PropTypes.array.isRequired,
  pickz: PropTypes.array.isRequired,
};

export default injectSheet(styles)(GroupM);
